import queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { bindActionCreators } from 'redux';
import { sessionActions } from '../../state/modules/session';
import { Loading } from './';

/**
 * Responsible of rendering login loading and redirecting to our Auth0 login page
 */

const Login = () => (
  <Loading />
);

function performLogin(currentProps) {
  const customRedirect = currentProps.lastPage ? currentProps.lastPage : '';
  const invitationToken = queryString.parse(currentProps.location.search).invitationToken;
  if (currentProps.auth0Config && !currentProps.isLoggingOut) {
    currentProps.login(invitationToken, new Buffer(customRedirect).toString('base64'))
  }
}

const mapStateToProps = (state) => ({
  auth0Config: state.configuration.auth0Config,
  session: state.session,
  isLoggingOut: state.session.isLoggingOut,
  lastPage: state.session.lastPath
});

const mapDispatchToProps = (dispatch) => ({
  login: bindActionCreators(sessionActions.session.login, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      performLogin(this.props)
    },
    componentWillReceiveProps(nextProps) {
      performLogin(nextProps)
    }
  }),
)(Login);



// WEBPACK FOOTER //
// ./src/containers/pages/login.js